import { useState } from "react";
import { MultiSelectListView } from "../SelectListView/MultiSelectListView";
import { FilterPill } from "./FilterPill";
import {
  FilterValue,
  MultiSelectFilter,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import { TrackingProps } from "../../types/component";

interface PillMultiSelectProps {
  filter: MultiSelectFilter;
  filterValue: FilterValue;
  selected: StringArrayFilterValue;
  onChange: (option: SelectOption, isSelected: boolean) => void;
  tracking: TrackingProps;
}

export const PillMultiSelect = ({
  filter,
  filterValue,
  selected,
  onChange,
  tracking,
}: PillMultiSelectProps) => {
  const [listBoxIsOpen, setListBoxIsOpen] = useState(false);
  return (
    <FilterPill
      filter={filter}
      listBoxIsOpen={listBoxIsOpen}
      setListBoxIsOpen={setListBoxIsOpen}
      selected={filterValue !== filter.defaultValue}
      tracking={{
        ...tracking,
        name: "multiselect_pill",
      }}
    >
      <MultiSelectListView
        prefix="pill"
        filter={filter}
        selected={selected}
        onChange={(option, isSelected) => {
          onChange(option, isSelected);
        }}
      />
    </FilterPill>
  );
};
